var defaultUserPic = "/home/circleci/app/src/assets/user.svg";

export { defaultUserPic as default };
